/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateBillingDetailsDataLocaleSchema = z.enum(['en-GB', 'de-DE', 'fi-FI'])

export type UpdateBillingDetailsDataLocaleSchema = z.infer<typeof updateBillingDetailsDataLocaleSchema>
